import { OPENING_RANGE } from './indicators/session'

export const ORB_BLOCK_KEY = 'orb-block-enabled'

const NY_TZ = 'America/New_York'

const NY_PARTS_FMT = new Intl.DateTimeFormat('en-US', {
  timeZone: NY_TZ,
  hour12: false,
  weekday: 'short',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
})

interface NyNow {
  y: number
  m: number
  d: number
  weekday: string
  minutes: number
}

function nyNow(now: Date = new Date()): NyNow {
  const parts = NY_PARTS_FMT.formatToParts(now)
  let y = 0, m = 0, d = 0, hour = 0, minute = 0, weekday = ''
  for (const p of parts) {
    if (p.type === 'year') y = parseInt(p.value, 10)
    else if (p.type === 'month') m = parseInt(p.value, 10)
    else if (p.type === 'day') d = parseInt(p.value, 10)
    else if (p.type === 'hour') hour = parseInt(p.value, 10) % 24
    else if (p.type === 'minute') minute = parseInt(p.value, 10)
    else if (p.type === 'weekday') weekday = p.value
  }
  return { y, m, d, weekday, minutes: hour * 60 + minute }
}

function nyWallClockToUtcMs(y: number, month: number, d: number, hour: number, minute: number): number {
  // EST guess (UTC-5). If formatting back gives wrong hour, snap to EDT (UTC-4).
  const estGuess = Date.UTC(y, month - 1, d, hour + 5, minute)
  const checkFmt = new Intl.DateTimeFormat('en-US', {
    timeZone: NY_TZ,
    hour12: false,
    hour: 'numeric',
  })
  const got = parseInt(
    checkFmt.formatToParts(estGuess).find((p) => p.type === 'hour')?.value ?? '-1',
    10,
  )
  const normalized = got === 24 ? 0 : got
  if (normalized === hour) return estGuess
  return Date.UTC(y, month - 1, d, hour + 4, minute)
}

export interface OrbWindowToday {
  startMs: number
  endMs: number
}

export function orbWindowToday(now: Date = new Date()): OrbWindowToday {
  const n = nyNow(now)
  const [sh, sm] = OPENING_RANGE.start
  const [eh, em] = OPENING_RANGE.end
  return {
    startMs: nyWallClockToUtcMs(n.y, n.m, n.d, sh, sm),
    endMs: nyWallClockToUtcMs(n.y, n.m, n.d, eh, em),
  }
}

export type OrbPhase = 'before' | 'forming' | 'finalized' | 'closed' | 'weekend'

export function orbPhase(now: Date = new Date()): OrbPhase {
  const n = nyNow(now)
  if (n.weekday === 'Sat' || n.weekday === 'Sun') return 'weekend'
  const startMin = OPENING_RANGE.start[0] * 60 + OPENING_RANGE.start[1]
  const endMin = OPENING_RANGE.end[0] * 60 + OPENING_RANGE.end[1]
  const closeMin = 16 * 60
  if (n.minutes < startMin) return 'before'
  if (n.minutes < endMin) return 'forming'
  if (n.minutes < closeMin) return 'finalized'
  return 'closed'
}
